import styled from 'styled-components';

export const Icon = styled.span`
  font-size: ${props => props.size ?? '24px'} !important;
  color: ${({ color, theme }) => (color ? theme.colors[color] : 'unset')};
`;
